import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel'
//
// const initSliders = () => {
//   $('.js-slider .slider__slides')
//     .slick({
//       adaptiveHeight: true,
//       dots: true,
//     });
// };
//
// $(window)
//   .on('load', () => {
//     initSliders();
//   });

// document.querySelectorAll('.js-slider .slider__slides')
//     .slick({
//       adaptiveHeight: true,
//       dots: true,
//     });

//require('slick-carousel');

$(document).ready(function () {
  if($('.js-slider .slider__slides .slider__slide').length > 1) {
    $('.js-slider .slider__slides')
      .slick({
        adaptiveHeight: true,
        dots: true,
      });
  }
});

